import { ContactDto } from "../models"

export const CONTACT_ACTION_TYPES = {
    CHECK_DUPLICATED_EMAIL: "CHECK_DUPLICATED_EMAIL" as const,
    CHECK_DUPLICATED_PHONE_NUMBER: "CHECK_DUPLICATED_PHONE_NUMBER" as const,
    UPSERT_CONTACT: "UPSERT_CONTACT" as const,
    FETCH_CONTACT: "FETCH_CONTACT" as const,
    DELETE_CONTACT:"DELETE_CONTACT" as const
}

export type Actions =
    | { type: typeof CONTACT_ACTION_TYPES.CHECK_DUPLICATED_EMAIL, payload: string[] }
    | { type: typeof CONTACT_ACTION_TYPES.CHECK_DUPLICATED_PHONE_NUMBER, payload: string[] }
    | { type: typeof CONTACT_ACTION_TYPES.UPSERT_CONTACT, payload: ContactDto }
    | { type: typeof CONTACT_ACTION_TYPES.DELETE_CONTACT, payload: ContactDto }


// WEBPACK FOOTER //
// ./src/state/contact/actions/types.ts